import axiosInstance from '../utils/axiosInstance';

export const deleteMatter = async (matterId: string): Promise<void> => {
  await axiosInstance.delete(`/matters/${matterId}`);
};
